import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerFeeNote/messages';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardTitle from 'containers/common/Card/CardTitle';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectNotifFeeNoteManager } from 'containers/AppContainer/selectors';
import { Listings } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import { Grid } from '@material-ui/core';
import {
  requestLawyerFeeNotes,
  requestAllFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteCosts,
  requestFeeNotesByPolicyNumber,
  requestUpdateFeeNoteAmount,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestFeeNotesByRegistrationNumber,
  requestFeeNotesByClaimNumb,
} from 'containers/LawyerFeeNote/actions';
import { FeeNoteContainer } from 'containers/LawyerFeeNote/styled-components';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import SearchBarFeeNote, { SearchQuery } from 'components/SearchBarFeeNote';
import FeeNoteTable from 'containers/LawyerFeeNote/FeeNoteTable';
import { Tab, Tabs } from '@material-ui/core';
import {
  STATUS_PENDING,
  STATUS_VALIDATED,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import { requestAllLawyerFeeNotes } from 'containers/LawyerFeeNote/actions';
import { ALL_STATUS } from 'containers/LawyerFeeNote/constants';
import { isEmpty, get } from 'lodash';

export interface LawyerFeeNoteProps {
  location: { pathname: string };
  intl: IntlShape;
  feeNotes: FeeNote[];
  feeNotesCount: number;
  countFeeNotes: number;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  documentId: string;
  setDocumentId: Function;
  requestLawyerFeeNotes: Function;
  requestAllFeeNotes: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteCosts: Function;
  keyclokToken: string | null;
  requestFeeNotesByClaimNumb: Function;
  requestFeeNotesByPolicyNumber: Function;
  listings: Listings;
  requestUpdateFeeNoteAmount: Function;
  loaders: any;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestAllLawyerFeeNotes: Function;
  notifFeeNote: any;
  requestFeeNotesByRegistrationNumber: Function;
}

export const LawyerFeeNote: React.FC<LawyerFeeNoteProps> = (
  props,
): JSX.Element => {
  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>({
    claimNumber: null,
    policyNumber: null,
  });

  const [page, setPage] = React.useState<number>(0);

  const handlerSearch = () => {
    if (searchQuery.claimNumber)
      return props.requestFeeNotesByClaimNumb(searchQuery.claimNumber);
    if (searchQuery.policyNumber)
      return props.requestFeeNotesByPolicyNumber(searchQuery.policyNumber);
    if (searchQuery.registrationNumber) {
      props.requestFeeNotesByRegistrationNumber(searchQuery.registrationNumber);
    }
  };

  const handlerRefresh = () => {
    setSearchQuery({
      claimNumber: null,
      policyNumber: null,
    });
    props.requestAllFeeNotes(0, 25);
  };
  const [selectedStatus, setSelectedStatus] = React.useState<null | string>(
    null,
  );

  const [tab, setTab] = React.useState(0);
  const [filtredFeeNotes, setFiltredFeeNotes] = React.useState<any>([]);

  React.useEffect(() => {
    if (!isEmpty(props.notifFeeNote)) {
      setTab(ALL_STATUS.indexOf(get(props.notifFeeNote, 'status')));
      props.requestAllLawyerFeeNotes(get(props.notifFeeNote, 'status'));
    }
  }, [props.notifFeeNote]);
  React.useEffect(() => {
    if (isEmpty(props.notifFeeNote)) {
      switch (tab) {
        case 0:
          setFiltredFeeNotes(
            props.feeNotes.filter(
              (feeNote: any) => feeNote.status === STATUS_PENDING,
            ),
          );
          setSelectedStatus(STATUS_PENDING);
          break;
        case 1:
          setFiltredFeeNotes(
            props.feeNotes.filter(
              (feeNote: any) => feeNote.status === STATUS_VALIDATED,
            ),
          );
          setSelectedStatus(STATUS_VALIDATED);
          break;
        case 2:
          setFiltredFeeNotes(
            props.feeNotes.filter(
              (feeNote: any) => feeNote.status === STATUS_REJECTED,
            ),
          );
          setSelectedStatus(STATUS_REJECTED);
          break;
      }
    }
  }, [tab, props.feeNotes, props.keyclokToken]);
  const handleChange = (event: React.ChangeEvent<{}>, newTabIndex: number) => {
    setTab(newTabIndex);
    setPage(0);
  };
  return (
    <FeeNoteContainer>
      <Card>
        <Tabs
          value={tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          className="tab-container"
        >
          <Tab
            label={translate(messages.pendingTabTitle, props)}
            data-testid="tab-1"
          />
          <Tab
            label={translate(messages.validatedTabTitle, props)}
            data-testid="tab-2"
          />
          <Tab
            label={translate(messages.rejectedTabTitle, props)}
            data-testid="tab-3"
          />
        </Tabs>
        <CardContent>
          <div className="header">
            <Grid container direction="row">
              <Grid item xs={8}>
                <CardTitle
                  count={filtredFeeNotes.length}
                  message={translate({ ...messages.feeNoteCardTitle }, props)}
                />
              </Grid>
              <Grid item xs={4}>
                <SearchBarFeeNote
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleSearch={handlerSearch}
                  handlerRefresh={handlerRefresh}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <FeeNoteTable
              feeNotes={
                !isEmpty(props.notifFeeNote)
                  ? props.feeNotes.filter(
                      (el: any) =>
                        el.id === Number(get(props.notifFeeNote, 'id')),
                    )
                  : filtredFeeNotes
              }
              feeNotesCount={props.feeNotesCount}
              requestFeeNotes={props.requestLawyerFeeNotes}
              requestAllFeeNotes={props.requestAllFeeNotes}
              requestCreateFeeNote={props.requestCreateFeeNote}
              requestFeeNoteCosts={props.requestFeeNoteCosts}
              keyclokToken={props.keyclokToken}
              resetUploadDocumentStore={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              showButtonAdd={true}
              listings={props.listings}
              viewByClaim={false}
              showStatusColumn={tab !== 0}
              selectedStatus={selectedStatus}
              setPage={setPage}
              page={page}
              isManager={false}
              requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
              requestManagerAllFeeNotes={() => {}}
              loaders={props.loaders}
              requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
              requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
              requestAllLawyerFeeNotes={props.requestAllLawyerFeeNotes}
              notifFeeNote={props.notifFeeNote}
            />
          </div>
        </CardContent>
      </Card>
    </FeeNoteContainer>
  );
};

const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestLawyerFeeNotes,
  requestAllFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteCosts,
  requestFeeNotesByClaimNumb,
  requestFeeNotesByPolicyNumber,
  requestUpdateFeeNoteAmount,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestAllLawyerFeeNotes,
  requestFeeNotesByRegistrationNumber,
};

export const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  listings: makeSelectListings(),
  notifFeeNote: makeSelectNotifFeeNoteManager(),
  loaders: selectedLoader,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LawyerFeeNote));
